import { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import ComplaintSummary from './ComplaintSummary';

export default function TenantComplaintDialog({ complaint, onClose }) {
  const [detail, setDetail] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [retry, setRetry] = useState(0);
  const id = complaint?.complaint_id;
  useEffect(() => {
    let active = true;
    setDetail(null);
    setError('');
    if (!id) return;
    setLoading(true);
    axios.get(`${process.env.REACT_APP_BACKEND_URL || ''}/api/tenant/complaints/${encodeURIComponent(id)}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('tenantToken')}` },
    }).then(res => { if (active) setDetail(res.data); })
      .catch(() => { if (active) setError('Detail komplain gagal dimuat. Silakan coba lagi.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [id, retry]);
  return <Dialog open={!!id} onOpenChange={open => { if (!open) onClose(); }}>
    <DialogContent className="block w-[calc(100%-2rem)] max-w-3xl max-h-[90dvh] overflow-y-auto rounded-2xl bg-white p-4 sm:p-6">
      <DialogTitle className="pr-6">Detail Komplain — {id}</DialogTitle>
      <DialogDescription className="mt-1 mb-4">Informasi komplain dan perkembangan penanganannya.</DialogDescription>
      {loading && <p role="status" className="py-8 text-center text-isk-muted">Memuat detail komplain...</p>}
      {error && <div role="alert" className="p-3 bg-red-50 text-red-700 rounded-lg">{error}<Button variant="outline" onClick={() => setRetry(value => value + 1)} className="ml-2">Coba Lagi</Button></div>}
      {!loading && !error && detail && <ComplaintSummary complaint={detail}
        photoUploadUrl={`${process.env.REACT_APP_BACKEND_URL || ''}/api/tenant/complaints/${encodeURIComponent(id)}/photo`}
        photoToken={localStorage.getItem('tenantToken')} onPhotoUpdated={data => setDetail(current => ({ ...current, ...data }))} />}
      <Button onClick={onClose} className="w-full mt-4 bg-isk-teal text-white rounded-full">Tutup</Button>
    </DialogContent>
  </Dialog>;
}
